import { Input, Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AnexoModalComponent } from './anexo.modal.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Anexo } from 'src/app/models/anexo.model';
import { AnexoService } from 'src/app/services/anexo.service';

@Component({
  selector: 'app-anexo-list-component',
  templateUrl: './anexo-list.component.html',
  styleUrls: ['./anexo-list.component.scss']
})

export class AnexoListComponent implements OnInit {
  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean;
  @Output() existeAnexo = new EventEmitter<boolean>();
  @Input() hiddenResume: boolean;

  anexos: Anexo[] = [];
  displayedColumns: string[] = ['nome', 'tipo', 'data', 'acoes'];
  dataSource = new MatTableDataSource<Anexo>();
  loading = false;

  constructor(private anexoService: AnexoService, private dialog: MatDialog, private toastr: ToastrComponent) {

  }

  carregarAnexos() {
    this.anexoService.getByEstimativaId(this.estimativaId).subscribe(anexos => {
      this.anexos = anexos.items;
      this.dataSource = new MatTableDataSource<Anexo>(this.anexos);

      this.existeAnexo.emit(anexos.items.length > 0);
    });
  }

  ngOnInit() {
    this.carregarAnexos();
  }

  download(id: number) {
    this.anexoService.getById(id).subscribe(anexo => {
      this.anexoService.download(id).subscribe(data => {
        const blob = new Blob([data], { type: anexo.contentType });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    });
  }

  excluir(id: number) {
    this.anexoService.excluirArquivo(id).subscribe(result => {
      if (result.mensagem.indexOf('sucesso') !== -1) {
        this.anexoService.delete(id).subscribe(() => {
          this.toastr.mostrarMensagem('sucesso', 'Sucesso', result.mensagem);
          this.carregarAnexos();
        });
      } else {
        this.toastr.mostrarMensagem('aviso', 'Atenção', result.mensagem);
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AnexoModalComponent, {
      width: '600px',
      height: '350px',
      data: {
        estimativaId: this.estimativaId,
        projetoId: 0,
        tipo: 'ANEXO',
        titulo: 'Upload de Arquivos',
        botaoCaption: 'Upload',
        acao: 'upload'
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.carregarAnexos();
    });
  }
}
